import { Button, Dialog, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import { ApiRequest } from "GlobalFunctions";

export default function CategoriesEditor(props : any) {

  /*=============================================
  VARIABLES FROM PROPS
  ============================================= */
  const {
    setLoading, 
    openEditor, 
    setOpenEditor, 
    category_id,
    loadList
  } = props;

  /*SNACKBAR FUNCTION FOR NOTIFICATIONS*/
  const { enqueueSnackbar } = useSnackbar();
  /*============================================= */
  
  const [categoryValues, setCategoryValues] = useState<any>({
    name: ""
  });

  /*=======================================
  GET CATEGORY DETAILS IF CATEGORY_ID EXISTS
  =======================================*/
  useEffect(() => {
    if (category_id && openEditor) {
      setLoading(true);
      ApiRequest({
        method: 'GET',
        url: '/admin/taxes/categories/details',
        query: { id: category_id },
        setResponse: (response: any) => {
          if (response) {
            setCategoryValues({
              id: response.id,
              name: response.name || ""
            });
          }
          setLoading(false);
        }
      });
    } else if (openEditor) {
      setCategoryValues({
        name: ""
      });
    }
  }, [openEditor, category_id]);

  /*=======================================
  SUBMIT FUNCTION
  =======================================*/
  const handleSubmit = () => {  
    if (!categoryValues.name.trim()) {
      enqueueSnackbar('Name is required', { variant: 'error' });
      return;
    }

    setLoading(true);
    
    ApiRequest({
      method: 'POST',
      url: '/admin/taxes/categories/addedit',
      body: {
        id: category_id || null,
        name: categoryValues.name.trim()
      },
      setResponse: (response: any) => {
        if(response.status === "success"){
          enqueueSnackbar(category_id ? 'Tax category updated successfully' : 'Tax category created successfully', { variant: 'success' });
          setOpenEditor(false);
          loadList();
        } else {
          enqueueSnackbar(response.message || 'Error saving tax category', { variant: 'error' });
        }
        setLoading(false);
      }
    });
  };

  /*=======================================
  HANDLE INPUT CHANGE
  =======================================*/
  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setCategoryValues({
      ...categoryValues,
      [name]: value
    });
  };

  /*=======================================
  HANDLE CLOSE
  =======================================*/
  const handleClose = () => {
    setOpenEditor(false);
    setCategoryValues({
      name: ""
    });
  };

  return (
    <>
      <Dialog 
        open={openEditor}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        PaperProps={{ sx: { borderRadius: "1.25rem", minWidth:"750px" } }}
      >
        <div className="DialogContainer">
          <div className="ModuleWrapper">
            <div className="boxContainerHeader">
              <div className="dialog_container_title">
                <h2 className="dialog_title">
                  {category_id ? "Edit Tax Category" : "Add Tax Category"}
                </h2>
              </div>
            </div>
            
            <div className="dialogFormContainer">
              <TextField
                name="name"
                label="Tax Category Name"
                value={categoryValues.name}
                onChange={handleInputChange}
                fullWidth
                required
                placeholder="Enter tax category name"
                variant="outlined"
                size="small"
              />
            </div>
          </div>
        </div>

        <div className="dialogButtons">
          <Button
            onClick={handleSubmit}
            variant="contained"
            className="button_1"
          >
            {category_id ? "Save Changes" : "Add Category"}
          </Button>

          <Button
            onClick={handleClose}
            variant="contained"
            color="secondary"
            className="button_secondary"
          >
            Cancel
          </Button>
        </div>
      </Dialog>
    </>
  );
}
